export interface HmbMock {
  sender: { id: string, name: string };
  receiver: { id: string, name: string };
  activeFrom: string | null;
  activeTo: string | null;
  senderRole?: string;
  receiverRole?: string;
  isActive: boolean;
  deleted: boolean;

}

export const hmbData: HmbMock[] = [
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002037646",
      "name": "Colruyt Food Retail N.V."
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "End User BNL",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-11-07T13:53:19.013Z"
  },
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002002998",
      "name": "Vanderpooten Primeurs N.V."
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-11-07T13:53:19.013Z"
  },
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002009623",
      "name": "Belgian Fresh Food N.V."
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Wholesaler BNL",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-06-20T07:18:42.110Z"
  },
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002023851",
      "name": "'T Sas N.V."
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-05-29T08:24:41.080Z"
  },
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002021924",
      "name": "Visserfruit"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-05-16T12:40:37.697Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021647",
      "name": "Belorta - category 8 INT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018640",
      "name": "K5033-SKW-VANDER ZIJPEN NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018618",
      "name": "K3457-SKW-FEVAL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018575",
      "name": "K2170-SKW-BUTTIENS FRUITS SA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018613",
      "name": "K3220-SKW-NORADIN SPRL"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018600",
      "name": "K2757-SKW-LEJEUNE NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018616",
      "name": "K3354-SKW-ROTOM GROENTEN EN FRUIT N"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018651",
      "name": "K5491-SKW-D.S.F. BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018680",
      "name": "K6953-SKW-GROSBUSCH MARCEL ET FILS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018617",
      "name": "K3406-SKW-CROTONI TRADING BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018601",
      "name": "K2759-SKW-VAN CLEYNENBREUGEL FRANS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018596",
      "name": "K2635-SKW-BOUVRY NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018643",
      "name": "K5122-SKW-PASCY BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021466",
      "name": "K4098-SKW-HEUFF FRUITBROKER BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021529",
      "name": "K6900-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018604",
      "name": "K2899-SKW-MAES FRUITEXPRESS BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018522",
      "name": "K3377-SKW-DE BLAEIJ VOF"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018598",
      "name": "K2650-SKW-BERGHMANS-VERBEECK KRIS"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018664",
      "name": "K6112-SKW-INPAK 3000 BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021496",
      "name": "K3335-SKW-DEVOS GROUP BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021534",
      "name": "K3983-SKW-BEKO"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021490",
      "name": "K2968-SKW-PLEVOETS JO"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018524",
      "name": "K4019-SKW-DE WIT J.P."
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018531",
      "name": "K5465-SKW-VAN OOIJEN BV GROENTEN EN"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018585",
      "name": "K2400-SKW-DBS NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018571",
      "name": "K2020-SKW-RETAIL PARTNERS COLRUYT G"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021481",
      "name": "K2296-SKW-STEEGMANS NORBERT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021519",
      "name": "K5526-SKW-JANDY BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021519",
      "name": "K5526-SKW-JANDY BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021470",
      "name": "K1055-SKW-BAKKER BELGIUM NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021527",
      "name": "K6607-SKW-VHL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018613",
      "name": "K3220-SKW-NORADIN SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002027038",
      "name": "CSK Yzewijn BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021522",
      "name": "K5923-SKW-VALO & CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021510",
      "name": "K3916-SKW-VIVOBOX – JOHAN VERGOTE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021507",
      "name": "K3790-SKW-TINY'S FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018517",
      "name": "K2770-SKW-LEVARHT J.M. EN ZN. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018628",
      "name": "K3820-SKW-COMPRA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018571",
      "name": "K2020-SKW-RETAIL PARTNERS COLRUYT G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021523",
      "name": "K6081-SKW-GROENHUIS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018596",
      "name": "K2635-SKW-BOUVRY NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018667",
      "name": "K6180-SKW-VEGEPACK SA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021648",
      "name": "Belorta - category 8 DE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021534",
      "name": "K3983-SKW-BEKO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018680",
      "name": "K6953-SKW-GROSBUSCH MARCEL ET FILS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018655",
      "name": "K5547-SKW-CONTINENTAL FRUIT COMPANY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021496",
      "name": "K3335-SKW-DEVOS GROUP BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021470",
      "name": "K1055-SKW-BAKKER BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021522",
      "name": "K5923-SKW-VALO & CO BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018384",
      "name": "Belorta - G.E.U.A. BNL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021470",
      "name": "K1055-SKW-BAKKER BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018613",
      "name": "K3220-SKW-NORADIN SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018673",
      "name": "K6845-SKW-ALLGRO NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018613",
      "name": "K3220-SKW-NORADIN SPRL"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018617",
      "name": "K3406-SKW-CROTONI TRADING BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018629",
      "name": "K3838-SKW-BOSPORUS BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018556",
      "name": "K1035-SKW-RODIERS EN ZONEN NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018619",
      "name": "K3479-SKW-N50 BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021509",
      "name": "K3803-SKW-VANDEWEGHE STIEVEN"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021490",
      "name": "K2968-SKW-PLEVOETS JO"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021508",
      "name": "K3800-SKW-Q-FRESH BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021500",
      "name": "K3568-SKW-VAN BRUSSELEN HANS"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021647",
      "name": "Belorta - category 8 INT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021648",
      "name": "Belorta - category 8 DE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018516",
      "name": "K1541-SKW-JAGER HOLLAND BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018529",
      "name": "K5360-SKW-VAN GEEST INTERNATIONAL"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018680",
      "name": "K6953-SKW-GROSBUSCH MARCEL ET FILS"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018588",
      "name": "K2500-SKW-DE PLECKER G.-LAUWERS NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018669",
      "name": "K6208-SKW-VALO & CO"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018516",
      "name": "K1541-SKW-JAGER HOLLAND BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018620",
      "name": "K3482-SKW-UNIK MARKET SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018524",
      "name": "K4019-SKW-DE WIT J.P."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018575",
      "name": "K2170-SKW-BUTTIENS FRUITS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021518",
      "name": "K3928-SKW-SWINNEN WESLEY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018522",
      "name": "K3377-SKW-DE BLAEIJ VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018557",
      "name": "K1037-SKW-FRUITHANDEL ROELANDT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018598",
      "name": "K2650-SKW-BERGHMANS-VERBEECK KRIS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018616",
      "name": "K3354-SKW-ROTOM GROENTEN EN FRUIT N"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021521",
      "name": "K5854-SKW-GERDO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018601",
      "name": "K2759-SKW-VAN CLEYNENBREUGEL FRANS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021508",
      "name": "K3800-SKW-Q-FRESH BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021648",
      "name": "Belorta - category 8 DE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021515",
      "name": "K5067-SKW-A.V.D. BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018512",
      "name": "K1150-SKW-TIMMERMANS BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021506",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018664",
      "name": "K6112-SKW-INPAK 3000 BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021476",
      "name": "K1998-SKW-V.C.B.T."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018669",
      "name": "K6208-SKW-VALO & CO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021491",
      "name": "K3188-SKW-STARFRESH LIEGE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021516",
      "name": "K5420-SKW-CEULEMANS-VAN BAAST BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018673",
      "name": "K6845-SKW-ALLGRO NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021466",
      "name": "K4098-SKW-HEUFF FRUITBROKER BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018672",
      "name": "K6825-SKW-BESTFOOD"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018673",
      "name": "K6845-SKW-ALLGRO NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021481",
      "name": "K2296-SKW-STEEGMANS NORBERT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002019024",
      "name": "Belorta - category 8 BNL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021470",
      "name": "K1055-SKW-BAKKER BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018616",
      "name": "K3354-SKW-ROTOM GROENTEN EN FRUIT N"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002019024",
      "name": "Belorta - category 8 BNL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "receiver": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018600",
      "name": "K2757-SKW-LEJEUNE NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021507",
      "name": "K3790-SKW-TINY'S FRUIT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021529",
      "name": "K6900-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021484",
      "name": "K2354-SKW-DENAEGHEL NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021505",
      "name": "K3730-SKW-SELECT GROENTEN EN FRUIT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018604",
      "name": "K2899-SKW-MAES FRUITEXPRESS BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018658",
      "name": "K5804-SKW-DE SMET CYRIEL NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018672",
      "name": "K6825-SKW-BESTFOOD"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018517",
      "name": "K2770-SKW-LEVARHT J.M. EN ZN. BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018527",
      "name": "K5275-SKW-VAN AARLE GEBR. BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018603",
      "name": "K2844-SKW-MICHIELS GEBROEDERS NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021500",
      "name": "K3568-SKW-VAN BRUSSELEN HANS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018600",
      "name": "K2757-SKW-LEJEUNE NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021491",
      "name": "K3188-SKW-STARFRESH LIEGE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021518",
      "name": "K3928-SKW-SWINNEN WESLEY"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021490",
      "name": "K2968-SKW-PLEVOETS JO"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021471",
      "name": "K1064-SKW-RFV FRUITS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018523",
      "name": "K3895-SKW-GROENTE EN FRUIT HET VITA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018571",
      "name": "K2020-SKW-RETAIL PARTNERS COLRUYT G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018605",
      "name": "K2918-SKW-COFRU NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018564",
      "name": "K1357-SKW-VERGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021515",
      "name": "K5067-SKW-A.V.D. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018588",
      "name": "K2500-SKW-DE PLECKER G.-LAUWERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018605",
      "name": "K2918-SKW-COFRU NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021516",
      "name": "K5420-SKW-CEULEMANS-VAN BAAST BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021492",
      "name": "K3213-SKW-HORTI-JOB"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018651",
      "name": "K5491-SKW-D.S.F. BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021493",
      "name": "K3214-SKW-GYBELS GROENTEN EN FRUIT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018516",
      "name": "K1541-SKW-JAGER HOLLAND BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021517",
      "name": "K5507-SKW-PAENHUYSEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018527",
      "name": "K5275-SKW-VAN AARLE GEBR. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018531",
      "name": "K5465-SKW-VAN OOIJEN BV GROENTEN EN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021521",
      "name": "K5854-SKW-GERDO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021469",
      "name": "K1050-SKW-COMTIE BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018527",
      "name": "K5275-SKW-VAN AARLE GEBR. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018529",
      "name": "K5360-SKW-VAN GEEST INTERNATIONAL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021471",
      "name": "K1064-SKW-RFV FRUITS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018626",
      "name": "K3529-SKW-AU PERE CLEMENT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018590",
      "name": "K2483-SKW-LAENEN FRUITHAL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018590",
      "name": "K2483-SKW-LAENEN FRUITHAL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018634",
      "name": "K3914-SKW-STERK BE BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021523",
      "name": "K6081-SKW-GROENHUIS"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018627",
      "name": "K3614-SKW-FRESH2B BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021470",
      "name": "K1055-SKW-BAKKER BELGIUM NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018564",
      "name": "K1357-SKW-VERGRO NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018527",
      "name": "K5275-SKW-VAN AARLE GEBR. BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018589",
      "name": "K2510-SKW-GEMEX BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018512",
      "name": "K1150-SKW-TIMMERMANS BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018628",
      "name": "K3820-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018667",
      "name": "K6180-SKW-VEGEPACK SA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021492",
      "name": "K3213-SKW-HORTI-JOB"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018627",
      "name": "K3614-SKW-FRESH2B BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021471",
      "name": "K1064-SKW-RFV FRUITS BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018513",
      "name": "K1264-SKW-SCHIFFER HARRY VOF"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018644",
      "name": "K5177-SKW-VAN RIET NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018619",
      "name": "K3479-SKW-N50 BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018629",
      "name": "K3838-SKW-BOSPORUS BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018556",
      "name": "K1035-SKW-RODIERS EN ZONEN NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021524",
      "name": "K6167-SKW-BUEDTS RENE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018516",
      "name": "K1541-SKW-JAGER HOLLAND BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021510",
      "name": "K3916-SKW-VIVOBOX – JOHAN VERGOTE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018555",
      "name": "K1020-SKW-UNISNIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018555",
      "name": "K1020-SKW-UNISNIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021544",
      "name": "K3747-SKW-CEYLAN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021519",
      "name": "K5526-SKW-JANDY BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018529",
      "name": "K5360-SKW-VAN GEEST INTERNATIONAL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021648",
      "name": "Belorta - category 8 DE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018663",
      "name": "K6066-SKW-BROVO BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018661",
      "name": "K5947-SKW-ORCA NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018663",
      "name": "K6066-SKW-BROVO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018661",
      "name": "K5947-SKW-ORCA NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018663",
      "name": "K6066-SKW-BROVO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018512",
      "name": "K1150-SKW-TIMMERMANS BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021496",
      "name": "K3335-SKW-DEVOS GROUP BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018655",
      "name": "K5547-SKW-CONTINENTAL FRUIT COMPANY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018585",
      "name": "K2400-SKW-DBS NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021484",
      "name": "K2354-SKW-DENAEGHEL NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018524",
      "name": "K4019-SKW-DE WIT J.P."
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018531",
      "name": "K5465-SKW-VAN OOIJEN BV GROENTEN EN"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019024",
      "name": "Belorta - category 8 BNL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021491",
      "name": "K3188-SKW-STARFRESH LIEGE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018590",
      "name": "K2483-SKW-LAENEN FRUITHAL BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021522",
      "name": "K5923-SKW-VALO & CO BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018644",
      "name": "K5177-SKW-VAN RIET NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018798",
      "name": "K4142-SKW-VLG GROSSVERBR.SUDWEST"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021544",
      "name": "K3747-SKW-CEYLAN"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018617",
      "name": "K3406-SKW-CROTONI TRADING BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018626",
      "name": "K3529-SKW-AU PERE CLEMENT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018627",
      "name": "K3614-SKW-FRESH2B BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018613",
      "name": "K3220-SKW-NORADIN SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018612",
      "name": "K3146-SKW-STARMEAL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018628",
      "name": "K3820-SKW-COMPRA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018596",
      "name": "K2635-SKW-BOUVRY NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021469",
      "name": "K1050-SKW-COMTIE BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018640",
      "name": "K5033-SKW-VANDER ZIJPEN NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018597",
      "name": "K2640-SKW-BOLLAERTS PRIMEURS NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021647",
      "name": "Belorta - category 8 INT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018557",
      "name": "K1037-SKW-FRUITHANDEL ROELANDT BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021519",
      "name": "K5526-SKW-JANDY BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018597",
      "name": "K2640-SKW-BOLLAERTS PRIMEURS NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018598",
      "name": "K2650-SKW-BERGHMANS-VERBEECK KRIS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021506",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021482",
      "name": "K2312-SKW-VEMACRO"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021527",
      "name": "K6607-SKW-VHL"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018584",
      "name": "K2394-SKW-DE WINNE GUY NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018603",
      "name": "K2844-SKW-MICHIELS GEBROEDERS NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018604",
      "name": "K2899-SKW-MAES FRUITEXPRESS BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021493",
      "name": "K3214-SKW-GYBELS GROENTEN EN FRUIT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018516",
      "name": "K1541-SKW-JAGER HOLLAND BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018597",
      "name": "K2640-SKW-BOLLAERTS PRIMEURS NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021466",
      "name": "K4098-SKW-HEUFF FRUITBROKER BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021496",
      "name": "K3335-SKW-DEVOS GROUP BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018575",
      "name": "K2170-SKW-BUTTIENS FRUITS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018571",
      "name": "K2020-SKW-RETAIL PARTNERS COLRUYT G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018588",
      "name": "K2500-SKW-DE PLECKER G.-LAUWERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021517",
      "name": "K5507-SKW-PAENHUYSEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018604",
      "name": "K2899-SKW-MAES FRUITEXPRESS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018584",
      "name": "K2394-SKW-DE WINNE GUY NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018517",
      "name": "K2770-SKW-LEVARHT J.M. EN ZN. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018585",
      "name": "K2400-SKW-DBS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018584",
      "name": "K2394-SKW-DE WINNE GUY NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021512",
      "name": "K4130-SKW-VERHEGGEN CVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018634",
      "name": "K3914-SKW-STERK BE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018601",
      "name": "K2759-SKW-VAN CLEYNENBREUGEL FRANS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021474",
      "name": "K1161-SKW-ELKE'S FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018557",
      "name": "K1037-SKW-FRUITHANDEL ROELANDT BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018604",
      "name": "K2899-SKW-MAES FRUITEXPRESS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018605",
      "name": "K2918-SKW-COFRU NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021534",
      "name": "K3983-SKW-BEKO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018512",
      "name": "K1150-SKW-TIMMERMANS BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018661",
      "name": "K5947-SKW-ORCA NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018512",
      "name": "K1150-SKW-TIMMERMANS BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018513",
      "name": "K1264-SKW-SCHIFFER HARRY VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018513",
      "name": "K1264-SKW-SCHIFFER HARRY VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021492",
      "name": "K3213-SKW-HORTI-JOB"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018667",
      "name": "K6180-SKW-VEGEPACK SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021490",
      "name": "K2968-SKW-PLEVOETS JO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018512",
      "name": "K1150-SKW-TIMMERMANS BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021491",
      "name": "K3188-SKW-STARFRESH LIEGE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002034439",
      "name": "P1208-SKW-FRACHIBEL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018634",
      "name": "K3914-SKW-STERK BE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018557",
      "name": "K1037-SKW-FRUITHANDEL ROELANDT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021470",
      "name": "K1055-SKW-BAKKER BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021505",
      "name": "K3730-SKW-SELECT GROENTEN EN FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018618",
      "name": "K3457-SKW-FEVAL BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018604",
      "name": "K2899-SKW-MAES FRUITEXPRESS BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018667",
      "name": "K6180-SKW-VEGEPACK SA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018531",
      "name": "K5465-SKW-VAN OOIJEN BV GROENTEN EN"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021492",
      "name": "K3213-SKW-HORTI-JOB"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018644",
      "name": "K5177-SKW-VAN RIET NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021505",
      "name": "K3730-SKW-SELECT GROENTEN EN FRUIT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018618",
      "name": "K3457-SKW-FEVAL BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018663",
      "name": "K6066-SKW-BROVO BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018673",
      "name": "K6845-SKW-ALLGRO NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018612",
      "name": "K3146-SKW-STARMEAL"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018664",
      "name": "K6112-SKW-INPAK 3000 BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021517",
      "name": "K5507-SKW-PAENHUYSEN BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018671",
      "name": "K6772-SKW-WILLY WOUTERS EN CO BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018797",
      "name": "K3815-SKW-MICRO"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021503",
      "name": "K3637-SKW-YILMAZ AHMET"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021508",
      "name": "K3800-SKW-Q-FRESH BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021524",
      "name": "K6167-SKW-BUEDTS RENE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021489",
      "name": "K2916-SKW-OP DE BEECK GUY"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021496",
      "name": "K3335-SKW-DEVOS GROUP BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018531",
      "name": "K5465-SKW-VAN OOIJEN BV GROENTEN EN"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019024",
      "name": "Belorta - category 8 BNL"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021515",
      "name": "K5067-SKW-A.V.D. BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018616",
      "name": "K3354-SKW-ROTOM GROENTEN EN FRUIT N"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021462",
      "name": "K1296-SKW-VAN RAVENSWAAIJ S.C. BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019024",
      "name": "Belorta - category 8 BNL"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021501",
      "name": "K3581-SKW-BERNAERTS DIRK"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034439",
      "name": "P1208-SKW-FRACHIBEL"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021469",
      "name": "K1050-SKW-COMTIE BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018658",
      "name": "K5804-SKW-DE SMET CYRIEL NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021519",
      "name": "K5526-SKW-JANDY BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018567",
      "name": "K1409-SKW-WEISS J. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002027038",
      "name": "CSK Yzewijn BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018556",
      "name": "K1035-SKW-RODIERS EN ZONEN NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018600",
      "name": "K2757-SKW-LEJEUNE NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021523",
      "name": "K6081-SKW-GROENHUIS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021501",
      "name": "K3581-SKW-BERNAERTS DIRK"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018797",
      "name": "K3815-SKW-MICRO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018627",
      "name": "K3614-SKW-FRESH2B BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018571",
      "name": "K2020-SKW-RETAIL PARTNERS COLRUYT G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018661",
      "name": "K5947-SKW-ORCA NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018663",
      "name": "K6066-SKW-BROVO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018658",
      "name": "K5804-SKW-DE SMET CYRIEL NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021489",
      "name": "K2916-SKW-OP DE BEECK GUY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018644",
      "name": "K5177-SKW-VAN RIET NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021516",
      "name": "K5420-SKW-CEULEMANS-VAN BAAST BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018673",
      "name": "K6845-SKW-ALLGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002033625",
      "name": "SAS Charlet Bazon - Nord Primeurs"
    },
    "receiver": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018671",
      "name": "K6772-SKW-WILLY WOUTERS EN CO BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018664",
      "name": "K6112-SKW-INPAK 3000 BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021482",
      "name": "K2312-SKW-VEMACRO"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019024",
      "name": "Belorta - category 8 BNL"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018658",
      "name": "K5804-SKW-DE SMET CYRIEL NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021518",
      "name": "K3928-SKW-SWINNEN WESLEY"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018616",
      "name": "K3354-SKW-ROTOM GROENTEN EN FRUIT N"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021469",
      "name": "K1050-SKW-COMTIE BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018522",
      "name": "K3377-SKW-DE BLAEIJ VOF"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018605",
      "name": "K2918-SKW-COFRU NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021493",
      "name": "K3214-SKW-GYBELS GROENTEN EN FRUIT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021507",
      "name": "K3790-SKW-TINY'S FRUIT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018524",
      "name": "K4019-SKW-DE WIT J.P."
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021517",
      "name": "K5507-SKW-PAENHUYSEN BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018523",
      "name": "K3895-SKW-GROENTE EN FRUIT HET VITA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018601",
      "name": "K2759-SKW-VAN CLEYNENBREUGEL FRANS"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021476",
      "name": "K1998-SKW-V.C.B.T."
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018588",
      "name": "K2500-SKW-DE PLECKER G.-LAUWERS NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018620",
      "name": "K3482-SKW-UNIK MARKET SPRL"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021496",
      "name": "K3335-SKW-DEVOS GROUP BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018564",
      "name": "K1357-SKW-VERGRO NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018596",
      "name": "K2635-SKW-BOUVRY NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018626",
      "name": "K3529-SKW-AU PERE CLEMENT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034439",
      "name": "P1208-SKW-FRACHIBEL"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018655",
      "name": "K5547-SKW-CONTINENTAL FRUIT COMPANY"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032263",
      "name": "K1194-SKW-MERCAT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018618",
      "name": "K3457-SKW-FEVAL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018617",
      "name": "K3406-SKW-CROTONI TRADING BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018619",
      "name": "K3479-SKW-N50 BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018629",
      "name": "K3838-SKW-BOSPORUS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018531",
      "name": "K5465-SKW-VAN OOIJEN BV GROENTEN EN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018626",
      "name": "K3529-SKW-AU PERE CLEMENT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018600",
      "name": "K2757-SKW-LEJEUNE NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021524",
      "name": "K6167-SKW-BUEDTS RENE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021509",
      "name": "K3803-SKW-VANDEWEGHE STIEVEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021501",
      "name": "K3581-SKW-BERNAERTS DIRK"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018798",
      "name": "K4142-SKW-VLG GROSSVERBR.SUDWEST"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002032263",
      "name": "K1194-SKW-MERCAT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021527",
      "name": "K6607-SKW-VHL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018564",
      "name": "K1357-SKW-VERGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021522",
      "name": "K5923-SKW-VALO & CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021523",
      "name": "K6081-SKW-GROENHUIS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021518",
      "name": "K3928-SKW-SWINNEN WESLEY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018672",
      "name": "K6825-SKW-BESTFOOD"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021503",
      "name": "K3637-SKW-YILMAZ AHMET"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018564",
      "name": "K1357-SKW-VERGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021484",
      "name": "K2354-SKW-DENAEGHEL NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018671",
      "name": "K6772-SKW-WILLY WOUTERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018671",
      "name": "K6772-SKW-WILLY WOUTERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018672",
      "name": "K6825-SKW-BESTFOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018651",
      "name": "K5491-SKW-D.S.F. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018653",
      "name": "K5532-SKW-VERDOODT FRANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018680",
      "name": "K6953-SKW-GROSBUSCH MARCEL ET FILS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021489",
      "name": "K2916-SKW-OP DE BEECK GUY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018658",
      "name": "K5804-SKW-DE SMET CYRIEL NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021491",
      "name": "K3188-SKW-STARFRESH LIEGE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021492",
      "name": "K3213-SKW-HORTI-JOB"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018605",
      "name": "K2918-SKW-COFRU NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021462",
      "name": "K1296-SKW-VAN RAVENSWAAIJ S.C. BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021527",
      "name": "K6607-SKW-VHL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018564",
      "name": "K1357-SKW-VERGRO NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021518",
      "name": "K3928-SKW-SWINNEN WESLEY"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021524",
      "name": "K6167-SKW-BUEDTS RENE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021510",
      "name": "K3916-SKW-VIVOBOX – JOHAN VERGOTE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018384",
      "name": "Belorta - G.E.U.A. BNL"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021462",
      "name": "K1296-SKW-VAN RAVENSWAAIJ S.C. BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021471",
      "name": "K1064-SKW-RFV FRUITS BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021523",
      "name": "K6081-SKW-GROENHUIS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021469",
      "name": "K1050-SKW-COMTIE BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018523",
      "name": "K3895-SKW-GROENTE EN FRUIT HET VITA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018571",
      "name": "K2020-SKW-RETAIL PARTNERS COLRUYT G"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021471",
      "name": "K1064-SKW-RFV FRUITS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021521",
      "name": "K5854-SKW-GERDO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018627",
      "name": "K3614-SKW-FRESH2B BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021466",
      "name": "K4098-SKW-HEUFF FRUITBROKER BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021474",
      "name": "K1161-SKW-ELKE'S FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021491",
      "name": "K3188-SKW-STARFRESH LIEGE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021648",
      "name": "Belorta - category 8 DE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018612",
      "name": "K3146-SKW-STARMEAL"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018626",
      "name": "K3529-SKW-AU PERE CLEMENT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018669",
      "name": "K6208-SKW-VALO & CO"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021512",
      "name": "K4130-SKW-VERHEGGEN CVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021501",
      "name": "K3581-SKW-BERNAERTS DIRK"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002027038",
      "name": "CSK Yzewijn BE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021484",
      "name": "K2354-SKW-DENAEGHEL NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018522",
      "name": "K3377-SKW-DE BLAEIJ VOF"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018634",
      "name": "K3914-SKW-STERK BE BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018613",
      "name": "K3220-SKW-NORADIN SPRL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018640",
      "name": "K5033-SKW-VANDER ZIJPEN NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018651",
      "name": "K5491-SKW-D.S.F. BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021501",
      "name": "K3581-SKW-BERNAERTS DIRK"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021484",
      "name": "K2354-SKW-DENAEGHEL NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018588",
      "name": "K2500-SKW-DE PLECKER G.-LAUWERS NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018601",
      "name": "K2759-SKW-VAN CLEYNENBREUGEL FRANS"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018643",
      "name": "K5122-SKW-PASCY BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018596",
      "name": "K2635-SKW-BOUVRY NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018673",
      "name": "K6845-SKW-ALLGRO NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021518",
      "name": "K3928-SKW-SWINNEN WESLEY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018634",
      "name": "K3914-SKW-STERK BE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018589",
      "name": "K2510-SKW-GEMEX BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018584",
      "name": "K2394-SKW-DE WINNE GUY NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021510",
      "name": "K3916-SKW-VIVOBOX – JOHAN VERGOTE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021506",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021506",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021505",
      "name": "K3730-SKW-SELECT GROENTEN EN FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018585",
      "name": "K2400-SKW-DBS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018585",
      "name": "K2400-SKW-DBS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021507",
      "name": "K3790-SKW-TINY'S FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021544",
      "name": "K3747-SKW-CEYLAN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018555",
      "name": "K1020-SKW-UNISNIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018529",
      "name": "K5360-SKW-VAN GEEST INTERNATIONAL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018612",
      "name": "K3146-SKW-STARMEAL"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018671",
      "name": "K6772-SKW-WILLY WOUTERS EN CO BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021500",
      "name": "K3568-SKW-VAN BRUSSELEN HANS"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002027038",
      "name": "CSK Yzewijn BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021508",
      "name": "K3800-SKW-Q-FRESH BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018797",
      "name": "K3815-SKW-MICRO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021484",
      "name": "K2354-SKW-DENAEGHEL NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018512",
      "name": "K1150-SKW-TIMMERMANS BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018663",
      "name": "K6066-SKW-BROVO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018653",
      "name": "K5532-SKW-VERDOODT FRANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018673",
      "name": "K6845-SKW-ALLGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018673",
      "name": "K6845-SKW-ALLGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021476",
      "name": "K1998-SKW-V.C.B.T."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002019024",
      "name": "Belorta - category 8 BNL"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018619",
      "name": "K3479-SKW-N50 BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018667",
      "name": "K6180-SKW-VEGEPACK SA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018529",
      "name": "K5360-SKW-VAN GEEST INTERNATIONAL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018672",
      "name": "K6825-SKW-BESTFOOD"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018571",
      "name": "K2020-SKW-RETAIL PARTNERS COLRUYT G"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018670",
      "name": "K6402-SKW-LATHOUWERS EN CO BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018797",
      "name": "K3815-SKW-MICRO"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018798",
      "name": "K4142-SKW-VLG GROSSVERBR.SUDWEST"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021523",
      "name": "K6081-SKW-GROENHUIS"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002027038",
      "name": "CSK Yzewijn BE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018612",
      "name": "K3146-SKW-STARMEAL"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021521",
      "name": "K5854-SKW-GERDO NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018590",
      "name": "K2483-SKW-LAENEN FRUITHAL BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021482",
      "name": "K2312-SKW-VEMACRO"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018628",
      "name": "K3820-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018584",
      "name": "K2394-SKW-DE WINNE GUY NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018626",
      "name": "K3529-SKW-AU PERE CLEMENT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018664",
      "name": "K6112-SKW-INPAK 3000 BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018797",
      "name": "K3815-SKW-MICRO"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021512",
      "name": "K4130-SKW-VERHEGGEN CVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018384",
      "name": "Belorta - G.E.U.A. BNL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002019024",
      "name": "Belorta - category 8 BNL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002034439",
      "name": "P1208-SKW-FRACHIBEL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021470",
      "name": "K1055-SKW-BAKKER BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021469",
      "name": "K1050-SKW-COMTIE BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002034439",
      "name": "P1208-SKW-FRACHIBEL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018640",
      "name": "K5033-SKW-VANDER ZIJPEN NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018618",
      "name": "K3457-SKW-FEVAL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018628",
      "name": "K3820-SKW-COMPRA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018629",
      "name": "K3838-SKW-BOSPORUS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018522",
      "name": "K3377-SKW-DE BLAEIJ VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018584",
      "name": "K2394-SKW-DE WINNE GUY NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018567",
      "name": "K1409-SKW-WEISS J. BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021647",
      "name": "Belorta - category 8 INT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018590",
      "name": "K2483-SKW-LAENEN FRUITHAL BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018671",
      "name": "K6772-SKW-WILLY WOUTERS EN CO BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021489",
      "name": "K2916-SKW-OP DE BEECK GUY"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021524",
      "name": "K6167-SKW-BUEDTS RENE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018517",
      "name": "K2770-SKW-LEVARHT J.M. EN ZN. BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018661",
      "name": "K5947-SKW-ORCA NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021474",
      "name": "K1161-SKW-ELKE'S FRUIT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021476",
      "name": "K1998-SKW-V.C.B.T."
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021507",
      "name": "K3790-SKW-TINY'S FRUIT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018603",
      "name": "K2844-SKW-MICHIELS GEBROEDERS NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018567",
      "name": "K1409-SKW-WEISS J. BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018653",
      "name": "K5532-SKW-VERDOODT FRANS BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018605",
      "name": "K2918-SKW-COFRU NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018680",
      "name": "K6953-SKW-GROSBUSCH MARCEL ET FILS"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021505",
      "name": "K3730-SKW-SELECT GROENTEN EN FRUIT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021521",
      "name": "K5854-SKW-GERDO NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021534",
      "name": "K3983-SKW-BEKO"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018653",
      "name": "K5532-SKW-VERDOODT FRANS BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018555",
      "name": "K1020-SKW-UNISNIT BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021462",
      "name": "K1296-SKW-VAN RAVENSWAAIJ S.C. BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021503",
      "name": "K3637-SKW-YILMAZ AHMET"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018603",
      "name": "K2844-SKW-MICHIELS GEBROEDERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018567",
      "name": "K1409-SKW-WEISS J. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021522",
      "name": "K5923-SKW-VALO & CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018658",
      "name": "K5804-SKW-DE SMET CYRIEL NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018672",
      "name": "K6825-SKW-BESTFOOD"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018680",
      "name": "K6953-SKW-GROSBUSCH MARCEL ET FILS"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021648",
      "name": "Belorta - category 8 DE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021470",
      "name": "K1055-SKW-BAKKER BELGIUM NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018590",
      "name": "K2483-SKW-LAENEN FRUITHAL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018555",
      "name": "K1020-SKW-UNISNIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018600",
      "name": "K2757-SKW-LEJEUNE NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021510",
      "name": "K3916-SKW-VIVOBOX – JOHAN VERGOTE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021508",
      "name": "K3800-SKW-Q-FRESH BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021505",
      "name": "K3730-SKW-SELECT GROENTEN EN FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021527",
      "name": "K6607-SKW-VHL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021474",
      "name": "K1161-SKW-ELKE'S FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021506",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021500",
      "name": "K3568-SKW-VAN BRUSSELEN HANS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021534",
      "name": "K3983-SKW-BEKO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021484",
      "name": "K2354-SKW-DENAEGHEL NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018513",
      "name": "K1264-SKW-SCHIFFER HARRY VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018653",
      "name": "K5532-SKW-VERDOODT FRANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021482",
      "name": "K2312-SKW-VEMACRO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021491",
      "name": "K3188-SKW-STARFRESH LIEGE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021489",
      "name": "K2916-SKW-OP DE BEECK GUY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021490",
      "name": "K2968-SKW-PLEVOETS JO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018680",
      "name": "K6953-SKW-GROSBUSCH MARCEL ET FILS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018658",
      "name": "K5804-SKW-DE SMET CYRIEL NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021516",
      "name": "K5420-SKW-CEULEMANS-VAN BAAST BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018651",
      "name": "K5491-SKW-D.S.F. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018644",
      "name": "K5177-SKW-VAN RIET NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018584",
      "name": "K2394-SKW-DE WINNE GUY NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018517",
      "name": "K2770-SKW-LEVARHT J.M. EN ZN. BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018589",
      "name": "K2510-SKW-GEMEX BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018588",
      "name": "K2500-SKW-DE PLECKER G.-LAUWERS NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002001633",
      "name": "Natursur, S.C.A. (Viator)"
    },
    "receiver": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021469",
      "name": "K1050-SKW-COMTIE BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021501",
      "name": "K3581-SKW-BERNAERTS DIRK"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021469",
      "name": "K1050-SKW-COMTIE BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018612",
      "name": "K3146-SKW-STARMEAL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018522",
      "name": "K3377-SKW-DE BLAEIJ VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018516",
      "name": "K1541-SKW-JAGER HOLLAND BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018618",
      "name": "K3457-SKW-FEVAL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018627",
      "name": "K3614-SKW-FRESH2B BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021462",
      "name": "K1296-SKW-VAN RAVENSWAAIJ S.C. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018658",
      "name": "K5804-SKW-DE SMET CYRIEL NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021493",
      "name": "K3214-SKW-GYBELS GROENTEN EN FRUIT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021500",
      "name": "K3568-SKW-VAN BRUSSELEN HANS"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021466",
      "name": "K4098-SKW-HEUFF FRUITBROKER BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021476",
      "name": "K1998-SKW-V.C.B.T."
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018627",
      "name": "K3614-SKW-FRESH2B BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018651",
      "name": "K5491-SKW-D.S.F. BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018653",
      "name": "K5532-SKW-VERDOODT FRANS BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018638",
      "name": "K4000-SKW-BODSON PRIMEURS SPRL"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018798",
      "name": "K4142-SKW-VLG GROSSVERBR.SUDWEST"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018527",
      "name": "K5275-SKW-VAN AARLE GEBR. BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021512",
      "name": "K4130-SKW-VERHEGGEN CVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021509",
      "name": "K3803-SKW-VANDEWEGHE STIEVEN"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018601",
      "name": "K2759-SKW-VAN CLEYNENBREUGEL FRANS"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032263",
      "name": "K1194-SKW-MERCAT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018557",
      "name": "K1037-SKW-FRUITHANDEL ROELANDT BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018589",
      "name": "K2510-SKW-GEMEX BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021474",
      "name": "K1161-SKW-ELKE'S FRUIT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018585",
      "name": "K2400-SKW-DBS NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018598",
      "name": "K2650-SKW-BERGHMANS-VERBEECK KRIS"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021481",
      "name": "K2296-SKW-STEEGMANS NORBERT"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018522",
      "name": "K3377-SKW-DE BLAEIJ VOF"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018384",
      "name": "Belorta - G.E.U.A. BNL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018513",
      "name": "K1264-SKW-SCHIFFER HARRY VOF"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018627",
      "name": "K3614-SKW-FRESH2B BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002027038",
      "name": "CSK Yzewijn BE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018384",
      "name": "Belorta - G.E.U.A. BNL"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021463",
      "name": "K3572-SKW-BRIMA FRUIT BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018557",
      "name": "K1037-SKW-FRUITHANDEL ROELANDT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021466",
      "name": "K4098-SKW-HEUFF FRUITBROKER BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018554",
      "name": "K1018-SKW-ISPC  LIEGE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021507",
      "name": "K3790-SKW-TINY'S FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018797",
      "name": "K3815-SKW-MICRO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018640",
      "name": "K5033-SKW-VANDER ZIJPEN NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018523",
      "name": "K3895-SKW-GROENTE EN FRUIT HET VITA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018596",
      "name": "K2635-SKW-BOUVRY NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018585",
      "name": "K2400-SKW-DBS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018600",
      "name": "K2757-SKW-LEJEUNE NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021523",
      "name": "K6081-SKW-GROENHUIS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021524",
      "name": "K6167-SKW-BUEDTS RENE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021507",
      "name": "K3790-SKW-TINY'S FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021501",
      "name": "K3581-SKW-BERNAERTS DIRK"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021529",
      "name": "K6900-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018626",
      "name": "K3529-SKW-AU PERE CLEMENT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021462",
      "name": "K1296-SKW-VAN RAVENSWAAIJ S.C. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018598",
      "name": "K2650-SKW-BERGHMANS-VERBEECK KRIS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018797",
      "name": "K3815-SKW-MICRO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018555",
      "name": "K1020-SKW-UNISNIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018663",
      "name": "K6066-SKW-BROVO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021481",
      "name": "K2296-SKW-STEEGMANS NORBERT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021493",
      "name": "K3214-SKW-GYBELS GROENTEN EN FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018644",
      "name": "K5177-SKW-VAN RIET NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018673",
      "name": "K6845-SKW-ALLGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021476",
      "name": "K1998-SKW-V.C.B.T."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021484",
      "name": "K2354-SKW-DENAEGHEL NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018667",
      "name": "K6180-SKW-VEGEPACK SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021482",
      "name": "K2312-SKW-VEMACRO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018644",
      "name": "K5177-SKW-VAN RIET NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018671",
      "name": "K6772-SKW-WILLY WOUTERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021489",
      "name": "K2916-SKW-OP DE BEECK GUY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021490",
      "name": "K2968-SKW-PLEVOETS JO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002026965",
      "name": "Bingo Trans BVBA"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018643",
      "name": "K5122-SKW-PASCY BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018629",
      "name": "K3838-SKW-BOSPORUS BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018616",
      "name": "K3354-SKW-ROTOM GROENTEN EN FRUIT N"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018522",
      "name": "K3377-SKW-DE BLAEIJ VOF"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018634",
      "name": "K3914-SKW-STERK BE BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021515",
      "name": "K5067-SKW-A.V.D. BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018556",
      "name": "K1035-SKW-RODIERS EN ZONEN NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018643",
      "name": "K5122-SKW-PASCY BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021492",
      "name": "K3213-SKW-HORTI-JOB"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021509",
      "name": "K3803-SKW-VANDEWEGHE STIEVEN"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021512",
      "name": "K4130-SKW-VERHEGGEN CVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021534",
      "name": "K3983-SKW-BEKO"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018516",
      "name": "K1541-SKW-JAGER HOLLAND BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018585",
      "name": "K2400-SKW-DBS NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021521",
      "name": "K5854-SKW-GERDO NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018603",
      "name": "K2844-SKW-MICHIELS GEBROEDERS NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021471",
      "name": "K1064-SKW-RFV FRUITS BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021474",
      "name": "K1161-SKW-ELKE'S FRUIT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018564",
      "name": "K1357-SKW-VERGRO NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018616",
      "name": "K3354-SKW-ROTOM GROENTEN EN FRUIT N"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018619",
      "name": "K3479-SKW-N50 BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021481",
      "name": "K2296-SKW-STEEGMANS NORBERT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018619",
      "name": "K3479-SKW-N50 BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018619",
      "name": "K3479-SKW-N50 BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018517",
      "name": "K2770-SKW-LEVARHT J.M. EN ZN. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002019024",
      "name": "Belorta - category 8 BNL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021519",
      "name": "K5526-SKW-JANDY BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002027038",
      "name": "CSK Yzewijn BE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018601",
      "name": "K2759-SKW-VAN CLEYNENBREUGEL FRANS"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018571",
      "name": "K2020-SKW-RETAIL PARTNERS COLRUYT G"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018629",
      "name": "K3838-SKW-BOSPORUS BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018605",
      "name": "K2918-SKW-COFRU NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021510",
      "name": "K3916-SKW-VIVOBOX – JOHAN VERGOTE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021648",
      "name": "Belorta - category 8 DE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018643",
      "name": "K5122-SKW-PASCY BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018669",
      "name": "K6208-SKW-VALO & CO"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018590",
      "name": "K2483-SKW-LAENEN FRUITHAL BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018620",
      "name": "K3482-SKW-UNIK MARKET SPRL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018634",
      "name": "K3914-SKW-STERK BE BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021503",
      "name": "K3637-SKW-YILMAZ AHMET"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021489",
      "name": "K2916-SKW-OP DE BEECK GUY"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018643",
      "name": "K5122-SKW-PASCY BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018523",
      "name": "K3895-SKW-GROENTE EN FRUIT HET VITA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018567",
      "name": "K1409-SKW-WEISS J. BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018629",
      "name": "K3838-SKW-BOSPORUS BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021506",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018627",
      "name": "K3614-SKW-FRESH2B BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018798",
      "name": "K4142-SKW-VLG GROSSVERBR.SUDWEST"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021647",
      "name": "Belorta - category 8 INT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018651",
      "name": "K5491-SKW-D.S.F. BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018667",
      "name": "K6180-SKW-VEGEPACK SA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018513",
      "name": "K1264-SKW-SCHIFFER HARRY VOF"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018571",
      "name": "K2020-SKW-RETAIL PARTNERS COLRUYT G"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018527",
      "name": "K5275-SKW-VAN AARLE GEBR. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018529",
      "name": "K5360-SKW-VAN GEEST INTERNATIONAL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021471",
      "name": "K1064-SKW-RFV FRUITS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018628",
      "name": "K3820-SKW-COMPRA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018603",
      "name": "K2844-SKW-MICHIELS GEBROEDERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018617",
      "name": "K3406-SKW-CROTONI TRADING BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018564",
      "name": "K1357-SKW-VERGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021503",
      "name": "K3637-SKW-YILMAZ AHMET"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021515",
      "name": "K5067-SKW-A.V.D. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021515",
      "name": "K5067-SKW-A.V.D. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021544",
      "name": "K3747-SKW-CEYLAN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002032190",
      "name": "K1090-SKW-DOGER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021469",
      "name": "K1050-SKW-COMTIE BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021517",
      "name": "K5507-SKW-PAENHUYSEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018523",
      "name": "K3895-SKW-GROENTE EN FRUIT HET VITA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021462",
      "name": "K1296-SKW-VAN RAVENSWAAIJ S.C. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018589",
      "name": "K2510-SKW-GEMEX BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018589",
      "name": "K2510-SKW-GEMEX BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018556",
      "name": "K1035-SKW-RODIERS EN ZONEN NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021512",
      "name": "K4130-SKW-VERHEGGEN CVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021511",
      "name": "K4001-SKW-DV FRESH BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021507",
      "name": "K3790-SKW-TINY'S FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021509",
      "name": "K3803-SKW-VANDEWEGHE STIEVEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018798",
      "name": "K4142-SKW-VLG GROSSVERBR.SUDWEST"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002032263",
      "name": "K1194-SKW-MERCAT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021529",
      "name": "K6900-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018524",
      "name": "K4019-SKW-DE WIT J.P."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021500",
      "name": "K3568-SKW-VAN BRUSSELEN HANS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018661",
      "name": "K5947-SKW-ORCA NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018667",
      "name": "K6180-SKW-VEGEPACK SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018512",
      "name": "K1150-SKW-TIMMERMANS BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018672",
      "name": "K6825-SKW-BESTFOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018651",
      "name": "K5491-SKW-D.S.F. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018653",
      "name": "K5532-SKW-VERDOODT FRANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021480",
      "name": "K2277-SKW-EDELWEISS NEW"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021493",
      "name": "K3214-SKW-GYBELS GROENTEN EN FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021492",
      "name": "K3213-SKW-HORTI-JOB"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021490",
      "name": "K2968-SKW-PLEVOETS JO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021490",
      "name": "K2968-SKW-PLEVOETS JO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018644",
      "name": "K5177-SKW-VAN RIET NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018649",
      "name": "K5317-SKW-VANDERPOOTEN-ANCKAERT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018655",
      "name": "K5547-SKW-CONTINENTAL FRUIT COMPANY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018514",
      "name": "K1268-SKW-SMETS P. & ZN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018624",
      "name": "K3520-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018647",
      "name": "K5263-SKW-CAFRUTA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018596",
      "name": "K2635-SKW-BOUVRY NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018556",
      "name": "K1035-SKW-RODIERS EN ZONEN NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018513",
      "name": "K1264-SKW-SCHIFFER HARRY VOF"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018517",
      "name": "K2770-SKW-LEVARHT J.M. EN ZN. BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018634",
      "name": "K3914-SKW-STERK BE BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018798",
      "name": "K4142-SKW-VLG GROSSVERBR.SUDWEST"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034439",
      "name": "P1208-SKW-FRACHIBEL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018600",
      "name": "K2757-SKW-LEJEUNE NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021516",
      "name": "K5420-SKW-CEULEMANS-VAN BAAST BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032263",
      "name": "K1194-SKW-MERCAT"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021508",
      "name": "K3800-SKW-Q-FRESH BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021529",
      "name": "K6900-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021505",
      "name": "K3730-SKW-SELECT GROENTEN EN FRUIT"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018579",
      "name": "K2382-SKW-DEVLEESCHOUWER NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018653",
      "name": "K5532-SKW-VERDOODT FRANS BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018663",
      "name": "K6066-SKW-BROVO BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018641",
      "name": "K5069-SKW-VAN AKEN BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018634",
      "name": "K3914-SKW-STERK BE BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021462",
      "name": "K1296-SKW-VAN RAVENSWAAIJ S.C. BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018655",
      "name": "K5547-SKW-CONTINENTAL FRUIT COMPANY"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018588",
      "name": "K2500-SKW-DE PLECKER G.-LAUWERS NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021489",
      "name": "K2916-SKW-OP DE BEECK GUY"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018630",
      "name": "K3833-SKW-MARNA GROENTEN EN FRUIT B"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018527",
      "name": "K5275-SKW-VAN AARLE GEBR. BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018598",
      "name": "K2650-SKW-BERGHMANS-VERBEECK KRIS"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021466",
      "name": "K4098-SKW-HEUFF FRUITBROKER BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021516",
      "name": "K5420-SKW-CEULEMANS-VAN BAAST BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021517",
      "name": "K5507-SKW-PAENHUYSEN BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002024904",
      "name": "Roodpunt B.V.Kwek.-Import"
    },
    "receiver": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018524",
      "name": "K4019-SKW-DE WIT J.P."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021521",
      "name": "K5854-SKW-GERDO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002024817",
      "name": "Belorta - Import"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021518",
      "name": "K3928-SKW-SWINNEN WESLEY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018637",
      "name": "K3975-SKW-MIDYAT MARKET SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018636",
      "name": "K3972-SKW-SMEDING AGF BELGIË BVBA ("
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018597",
      "name": "K2640-SKW-BOLLAERTS PRIMEURS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021462",
      "name": "K1296-SKW-VAN RAVENSWAAIJ S.C. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021519",
      "name": "K5526-SKW-JANDY BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018617",
      "name": "K3406-SKW-CROTONI TRADING BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018517",
      "name": "K2770-SKW-LEVARHT J.M. EN ZN. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018614",
      "name": "K3224-SKW-ELITE GROENTEN EN FRUIT B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018612",
      "name": "K3146-SKW-STARMEAL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018611",
      "name": "K3144-SKW-BRUYNINCKX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021517",
      "name": "K5507-SKW-PAENHUYSEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018629",
      "name": "K3838-SKW-BOSPORUS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018590",
      "name": "K2483-SKW-LAENEN FRUITHAL BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018595",
      "name": "K2629-SKW-FA WAY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018628",
      "name": "K3820-SKW-COMPRA BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018620",
      "name": "K3482-SKW-UNIK MARKET SPRL"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018659",
      "name": "K5815-SKW-MAISON AMOROSO SA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018671",
      "name": "K6772-SKW-WILLY WOUTERS EN CO BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018651",
      "name": "K5491-SKW-D.S.F. BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021544",
      "name": "K3747-SKW-CEYLAN"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021507",
      "name": "K3790-SKW-TINY'S FRUIT"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021474",
      "name": "K1161-SKW-ELKE'S FRUIT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021482",
      "name": "K2312-SKW-VEMACRO"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021534",
      "name": "K3983-SKW-BEKO"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018591",
      "name": "K2556-SKW-FRUDICOM NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021508",
      "name": "K3800-SKW-Q-FRESH BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018555",
      "name": "K1020-SKW-UNISNIT BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021538",
      "name": "K3312-SKW-VEGROMIX"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021483",
      "name": "K2319-SKW-DE FRUITTOREN BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018581",
      "name": "K2386-SKW-VAN DIJK FOODS BELGIUM NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018524",
      "name": "K4019-SKW-DE WIT J.P."
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018601",
      "name": "K2759-SKW-VAN CLEYNENBREUGEL FRANS"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018626",
      "name": "K3529-SKW-AU PERE CLEMENT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021509",
      "name": "K3803-SKW-VANDEWEGHE STIEVEN"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021476",
      "name": "K1998-SKW-V.C.B.T."
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018531",
      "name": "K5465-SKW-VAN OOIJEN BV GROENTEN EN"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018795",
      "name": "K3561-SKW-FRÜCHTE HEEP GMBH"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018644",
      "name": "K5177-SKW-VAN RIET NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018657",
      "name": "K5645-SKW-DELAVAL LUC"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021524",
      "name": "K6167-SKW-BUEDTS RENE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021527",
      "name": "K6607-SKW-VHL"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018990",
      "name": "Belorta - G.E.U.A. INT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021508",
      "name": "K3800-SKW-Q-FRESH BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002029679",
      "name": "Belorta - Voedselbanken"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018520",
      "name": "K2003-SKW-AARTSENFRUIT BREDA BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018523",
      "name": "K3895-SKW-GROENTE EN FRUIT HET VITA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018640",
      "name": "K5033-SKW-VANDER ZIJPEN NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002019012",
      "name": "Retourcenter belOrta"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021474",
      "name": "K1161-SKW-ELKE'S FRUIT"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021508",
      "name": "K3800-SKW-Q-FRESH BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021523",
      "name": "K6081-SKW-GROENHUIS"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021517",
      "name": "K5507-SKW-PAENHUYSEN BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021544",
      "name": "K3747-SKW-CEYLAN"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018628",
      "name": "K3820-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021504",
      "name": "K3695-SKW-SLACHMUYLDERS ANN"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018604",
      "name": "K2899-SKW-MAES FRUITEXPRESS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018604",
      "name": "K2899-SKW-MAES FRUITEXPRESS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018610",
      "name": "K3202-SKW-VERBEECK DRY FOODS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018601",
      "name": "K2759-SKW-VAN CLEYNENBREUGEL FRANS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021503",
      "name": "K3637-SKW-YILMAZ AHMET"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021515",
      "name": "K5067-SKW-A.V.D. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021512",
      "name": "K4130-SKW-VERHEGGEN CVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021510",
      "name": "K3916-SKW-VIVOBOX – JOHAN VERGOTE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021509",
      "name": "K3803-SKW-VANDEWEGHE STIEVEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021509",
      "name": "K3803-SKW-VANDEWEGHE STIEVEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021648",
      "name": "Belorta - category 8 DE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021648",
      "name": "Belorta - category 8 DE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018798",
      "name": "K4142-SKW-VLG GROSSVERBR.SUDWEST"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018640",
      "name": "K5033-SKW-VANDER ZIJPEN NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018517",
      "name": "K2770-SKW-LEVARHT J.M. EN ZN. BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018523",
      "name": "K3895-SKW-GROENTE EN FRUIT HET VITA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018559",
      "name": "K1195-SKW-VANCO BELGIUM NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002032303",
      "name": "K1153-SKW-ALEX"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018597",
      "name": "K2640-SKW-BOLLAERTS PRIMEURS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018594",
      "name": "K2615-SKW-HOES FRUITS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018798",
      "name": "K4142-SKW-VLG GROSSVERBR.SUDWEST"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021529",
      "name": "K6900-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018664",
      "name": "K6112-SKW-INPAK 3000 BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018669",
      "name": "K6208-SKW-VALO & CO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021481",
      "name": "K2296-SKW-STEEGMANS NORBERT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021491",
      "name": "K3188-SKW-STARFRESH LIEGE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021484",
      "name": "K2354-SKW-DENAEGHEL NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018513",
      "name": "K1264-SKW-SCHIFFER HARRY VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018671",
      "name": "K6772-SKW-WILLY WOUTERS EN CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021478",
      "name": "K2013-SKW-AWS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018655",
      "name": "K5547-SKW-CONTINENTAL FRUIT COMPANY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018646",
      "name": "K5188-SKW-FRUITMARKT COOLS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018678",
      "name": "K6905-SKW-GREENYARD FRESH B. LOC 8"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018674",
      "name": "K6868-SKW-KEIRSMAEKERS EN ZOON BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021533",
      "name": "K3933-SKW-SWINNEN FAM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021496",
      "name": "K3335-SKW-DEVOS GROUP BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002018991",
      "name": "Belorta - G.E.U.A. DE"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018598",
      "name": "K2650-SKW-BERGHMANS-VERBEECK KRIS"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021468",
      "name": "K5832-SKW-VAN OERS UNITED BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018661",
      "name": "K5947-SKW-ORCA NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018555",
      "name": "K1020-SKW-UNISNIT BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018640",
      "name": "K5033-SKW-VANDER ZIJPEN NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018648",
      "name": "K5298-SKW-GOOSSENS BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018655",
      "name": "K5547-SKW-CONTINENTAL FRUIT COMPANY"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018658",
      "name": "K5804-SKW-DE SMET CYRIEL NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018513",
      "name": "K1264-SKW-SCHIFFER HARRY VOF"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018667",
      "name": "K6180-SKW-VEGEPACK SA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018639",
      "name": "K4134-SKW-FRESH FOOD VANLOMMEL BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018796",
      "name": "K3721-SKW-ROSENLAND FRUCHTIMPORT KG"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018596",
      "name": "K2635-SKW-BOUVRY NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018626",
      "name": "K3529-SKW-AU PERE CLEMENT"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018676",
      "name": "K6901-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021482",
      "name": "K2312-SKW-VEMACRO"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018527",
      "name": "K5275-SKW-VAN AARLE GEBR. BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018563",
      "name": "K1289-SKW-VANLOMMEL EN CO NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018597",
      "name": "K2640-SKW-BOLLAERTS PRIMEURS NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018516",
      "name": "K1541-SKW-JAGER HOLLAND BV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018604",
      "name": "K2899-SKW-MAES FRUITEXPRESS BVBA"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021524",
      "name": "K6167-SKW-BUEDTS RENE"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018566",
      "name": "K1370-SKW-VERVAEKE NV"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018575",
      "name": "K2170-SKW-BUTTIENS FRUITS SA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018655",
      "name": "K5547-SKW-CONTINENTAL FRUIT COMPANY"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018617",
      "name": "K3406-SKW-CROTONI TRADING BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018384",
      "name": "Belorta - G.E.U.A. BNL"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018519",
      "name": "K2790-SKW-LUKASSEN G.H. EN ZOON BV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018577",
      "name": "K2187-SKW-VANCOFRU BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021510",
      "name": "K3916-SKW-VIVOBOX – JOHAN VERGOTE"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002033280",
      "name": "K1250-SKW-SafakGmbH"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018588",
      "name": "K2500-SKW-DE PLECKER G.-LAUWERS NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021543",
      "name": "K1095-SKW-KIRANDI OBST - GEMÜSE"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018599",
      "name": "K2756-SKW-LEGU-FRUITS SPRL"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002033721",
      "name": "Aartsen Venlo B.V. - Import"
    },
    "receiver": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018384",
      "name": "Belorta - G.E.U.A. BNL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021647",
      "name": "Belorta - category 8 INT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "receiver": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018633",
      "name": "K3899-SKW-TIMUCIN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018621",
      "name": "K3486-SKW-T'SAS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021503",
      "name": "K3637-SKW-YILMAZ AHMET"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018642",
      "name": "K5097-SKW-BERCKMANS-VRANCKX NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021517",
      "name": "K5507-SKW-PAENHUYSEN BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018569",
      "name": "K1411-SKW-NICOLAI FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018582",
      "name": "K2390-SKW-HEYERICK PETER - VAN VOOR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018612",
      "name": "K3146-SKW-STARMEAL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034439",
      "name": "P1208-SKW-FRACHIBEL"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021473",
      "name": "K1118-SKW-STOFFERIS BVBA"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018631",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021532",
      "name": "K1134-SKW-STORMS RAF"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "receiver": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018613",
      "name": "K3220-SKW-NORADIN SPRL"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021509",
      "name": "K3803-SKW-VANDEWEGHE STIEVEN"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021531",
      "name": "K1094-SKW-JONNIAUX ERIC"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018526",
      "name": "K5234-SKW-SCHERPENHUIZEN BV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018605",
      "name": "K2918-SKW-COFRU NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018606",
      "name": "K2928-SKW-THIRY GENT NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002022323",
      "name": "Heideheuvel"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018523",
      "name": "K3895-SKW-GROENTE EN FRUIT HET VITA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018589",
      "name": "K2510-SKW-GEMEX BVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018625",
      "name": "K3579-SKW-ECB2"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021512",
      "name": "K4130-SKW-VERHEGGEN CVBA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018560",
      "name": "K1215-SKW-VAN DEN DRIESSCHE GR-FR B"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018597",
      "name": "K2640-SKW-BOLLAERTS PRIMEURS NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021518",
      "name": "K3928-SKW-SWINNEN WESLEY"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021525",
      "name": "K6201-SKW-VAN HUL LINDA"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021535",
      "name": "K1080-SKW-LA PROVENCALE S.A.R.L."
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018552",
      "name": "K1011-SKW-REMY JACQUES ET FILS SA"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021474",
      "name": "K1161-SKW-ELKE'S FRUIT"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018640",
      "name": "K5033-SKW-VANDER ZIJPEN NV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018521",
      "name": "K3108-SKW-RUITENBERG GEBR. BV"
    },
    "receiver": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021475",
      "name": "K1251-SKW-PELTRI SHOPPING"
    },
    "receiver": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021043",
      "name": "niet geregistreerde koper Intermedi"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018628",
      "name": "K3820-SKW-COMPRA BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021512",
      "name": "K4130-SKW-VERHEGGEN CVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034439",
      "name": "P1208-SKW-FRACHIBEL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018555",
      "name": "K1020-SKW-UNISNIT BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018660",
      "name": "K5836-SKW-RUTOMA BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018575",
      "name": "K2170-SKW-BUTTIENS FRUITS SA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018583",
      "name": "K2393-SKW-DE WITTE-DE CAUWER W."
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018619",
      "name": "K3479-SKW-N50 BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018623",
      "name": "K3517-SKW-NC FOODEXPRESS"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018655",
      "name": "K5547-SKW-CONTINENTAL FRUIT COMPANY"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018677",
      "name": "K6903-SKW-GREENYARD FRESH BELGIUM L"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021482",
      "name": "K2312-SKW-VEMACRO"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021490",
      "name": "K2968-SKW-PLEVOETS JO"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021047",
      "name": "niet geregistreerde koper End User"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021496",
      "name": "K3335-SKW-DEVOS GROUP BVBA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018518",
      "name": "K2581-SKW-IMPEX-HEEMSKERK BV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018529",
      "name": "K5360-SKW-VAN GEEST INTERNATIONAL"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021494",
      "name": "K3268-SKW-LEONARDO SA"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018578",
      "name": "K2365-SKW-BEL'EXPORT NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021492",
      "name": "K3213-SKW-HORTI-JOB"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021497",
      "name": "K3376-SKW-VOS MARNIX"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021499",
      "name": "K3551-SKW-CUVELIER FRUIT"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021526",
      "name": "K6253-SKW-WYTYNCK PIET"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021485",
      "name": "K2397-SKW-D'HONDT EN ZONEN BVBA"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021521",
      "name": "K5854-SKW-GERDO NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021492",
      "name": "K3213-SKW-HORTI-JOB"
    },
    "receiver": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "receiver": {
      "id": "NL17_001",
      "name": "Venlo"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021520",
      "name": "K5831-SKW-PITTOORS-DE WIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018632",
      "name": "K3898-SKW-ALEGRIAFRUIT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018532",
      "name": "K6063-SKW-HARRIE GOESTEN VOF"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018620",
      "name": "K3482-SKW-UNIK MARKET SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021518",
      "name": "K3928-SKW-SWINNEN WESLEY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018524",
      "name": "K4019-SKW-DE WIT J.P."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018635",
      "name": "K3957-SKW-BON BON TOMATOES BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018573",
      "name": "K2088-SKW-DE VUYST-MEIRSONNE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018593",
      "name": "K2572-SKW-MASSART BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018568",
      "name": "K1410-SKW-NICOLAI FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018596",
      "name": "K2635-SKW-BOUVRY NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018597",
      "name": "K2640-SKW-BOLLAERTS PRIMEURS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018587",
      "name": "K2435-SKW-EUROFRUITS SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018557",
      "name": "K1037-SKW-FRUITHANDEL ROELANDT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018558",
      "name": "K1075-SKW-FRUITHANDEL SEBRECHTS BVB"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018557",
      "name": "K1037-SKW-FRUITHANDEL ROELANDT BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021464",
      "name": "K3907-SKW-CEYDA BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018556",
      "name": "K1035-SKW-RODIERS EN ZONEN NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018567",
      "name": "K1409-SKW-WEISS J. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002027038",
      "name": "CSK Yzewijn BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018811",
      "name": "K6160-SKW-AUX HALLES DUVEAU ETS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021515",
      "name": "K5067-SKW-A.V.D. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021500",
      "name": "K3568-SKW-VAN BRUSSELEN HANS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021506",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021548",
      "name": "K1087-SKW-CITY OBST & GEMÜSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018793",
      "name": "K3219-SKW-KURBAN GMBH"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002025047",
      "name": "CSK Bodson Primeurs BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021529",
      "name": "K6900-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021529",
      "name": "K6900-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018516",
      "name": "K1541-SKW-JAGER HOLLAND BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018515",
      "name": "K1489-SKW-BIDI"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018629",
      "name": "K3838-SKW-BOSPORUS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018529",
      "name": "K5360-SKW-VAN GEEST INTERNATIONAL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018530",
      "name": "K5401-SKW-LEVARHT J.M. EN ZONEN BV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018620",
      "name": "K3482-SKW-UNIK MARKET SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018622",
      "name": "K3487-SKW-HEMPE SPRL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018574",
      "name": "K2141-SKW-BOUSSIER J. NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018592",
      "name": "K2529-SKW-EURO GIJBELS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021467",
      "name": "K5320-SKW-SMEDING & ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018603",
      "name": "K2844-SKW-MICHIELS GEBROEDERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018607",
      "name": "K2939-SKW-DELIDIS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018609",
      "name": "K3127-SKW-VERIS GROENTEN EN FRUIT G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018553",
      "name": "K1015-SKW-ISPC  GENT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018567",
      "name": "K1409-SKW-WEISS J. BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021521",
      "name": "K5854-SKW-GERDO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018562",
      "name": "K1242-SKW-VAN DIJCK FRERES SA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002027038",
      "name": "CSK Yzewijn BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018819",
      "name": "K3570-SKW-DURDIK PETR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021498",
      "name": "K3534-SKW-VERDONCK INGRID"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021513",
      "name": "K4139-SKW-DILLEN JAN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021514",
      "name": "K5022-SKW-DE VOS CARINE BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018799",
      "name": "K3891-SKW-W. ANDREE GBR"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021528",
      "name": "K6631-SKW-VANDERLINDEN EDDY"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021527",
      "name": "K6607-SKW-VHL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021530",
      "name": "K6911-SKW-GREENYARD FRESH DIRECT BE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018608",
      "name": "K2947-SKW-PEPINSTER PRIMEURS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021527",
      "name": "K6607-SKW-VHL"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002032145",
      "name": "K1144-SKW-FRESHCENTER"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018572",
      "name": "K2036-SKW-APPELTANTS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018586",
      "name": "K2424-SKW-FRUITPACKERS NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018605",
      "name": "K2918-SKW-COFRU NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021522",
      "name": "K5923-SKW-VALO & CO BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018794",
      "name": "K3298-SKW-OZDEMIR HATICE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018580",
      "name": "K2383-SKW-DUVA FRUIT NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021510",
      "name": "K3916-SKW-VIVOBOX – JOHAN VERGOTE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021534",
      "name": "K3983-SKW-BEKO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021537",
      "name": "K1340-SKW-VEILING ROESELARE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021541",
      "name": "K3623-SKW-PORT INTERNATIONAL E.S. G"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021542",
      "name": "K1025-SKW-PRIMA FRUCHT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018656",
      "name": "K5605-SKW-LESAGE J. EN ZOON"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021539",
      "name": "K3938-SKW-FRESH HOUSE"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021487",
      "name": "K2776-SKW-LIMBURGSE TUINBOUWVEILING"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018565",
      "name": "K1358-SKW-VERGRO NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018662",
      "name": "K6015-SKW-BIOFRESH BELGIUM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002018665",
      "name": "K6043-SKW-CLOQUETTE ALAIN DISTRIBUT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002018654",
      "name": "K5517-SKW-COOSEMANS BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021496",
      "name": "K3335-SKW-DEVOS GROUP BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002018664",
      "name": "K6112-SKW-INPAK 3000 BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "receiver": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021477",
      "name": "K2066-SKW-GROENTEN EN FRUIT BAETEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002018672",
      "name": "K6825-SKW-BESTFOOD"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021479",
      "name": "K2253-SKW-ANDIPRIM"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021493",
      "name": "K3214-SKW-GYBELS GROENTEN EN FRUIT"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018680",
      "name": "K6953-SKW-GROSBUSCH MARCEL ET FILS"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE24_001",
      "name": "Sint Truiden (BelOrta)"
    },
    "receiver": {
      "id": "0002021488",
      "name": "K2904-SKW-NUYTS MARLEEN"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018675",
      "name": "K6871-SKW-YZEWIJN - CO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE26_001",
      "name": "Glabbeek (BelOrta)"
    },
    "receiver": {
      "id": "0002021476",
      "name": "K1998-SKW-V.C.B.T."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002018666",
      "name": "K6131-SKW-FRESH FOOD DF NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021482",
      "name": "K2312-SKW-VEMACRO"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002018679",
      "name": "K6912-SKW-GREENYARD FRESH BELGIUM L"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "receiver": {
      "id": "0002021476",
      "name": "K1998-SKW-V.C.B.T."
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE25_001",
      "name": "Waasland (Belorta)"
    },
    "receiver": {
      "id": "0002021516",
      "name": "K5420-SKW-CEULEMANS-VAN BAAST BVBA"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "BE11_001",
      "name": "Katelijne"
    },
    "receiver": {
      "id": "0002021495",
      "name": "K3297-SKW-DSP FOOD NV"
    },
    "activeTo": null,
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002001853",
      "name": "BelOrta cvba"
    },
    "receiver": {
      "id": "0002030467",
      "name": "Primalof B.V."
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "receiverRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018668",
      "name": "K6203-SKW-VAWI NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021489",
      "name": "K2916-SKW-OP DE BEECK GUY"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018570",
      "name": "K2001-SKW-LGF BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002034485",
      "name": "P1291-SKW-Nova Natura"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018533",
      "name": "K6964-SKW-WILLEM DIJK AGF"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021486",
      "name": "K2593-SKW-HENDRICKX RIKA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018602",
      "name": "K2843-SKW-MICHIELS FRANS EN ZONEN N"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021470",
      "name": "K1055-SKW-BAKKER BELGIUM NV"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018567",
      "name": "K1409-SKW-WEISS J. BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018797",
      "name": "K3815-SKW-MICRO"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021506",
      "name": "K3764-SKW-AYA ASIAN FOOD"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018652",
      "name": "K5499-SKW-VAN VARENBERG LUDO BVBA"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002021540",
      "name": "K3971-SKW-DIRILIS 42"
    },
    "receiver": {
      "id": "BE16_001",
      "name": "Borgloon (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
  {
    "sender": {
      "id": "0002018576",
      "name": "K2176-SKW-CALSA NV"
    },
    "receiver": {
      "id": "BE17_001",
      "name": "Zellik (BelOrta)"
    },
    "activeTo": null,
    "senderRole": "Intermediate",
    "isActive": true,
    "deleted": false,
    "activeFrom": "2023-01-25T12:49:47.213Z"
  },
];
